<template>
    <div class="image-slider mt-md-4" v-if="imgs">
        <template v-if="imgs.length > 1">
            <div class="image-slider-main">
                <slick ref="sliderMain" class="slick-slider slick-slider-main" :options="slickOptionsMain">
                    <template v-for="(img, i) in imgs">
                        <img v-if="img.medium" :src="img.medium" :key="i">
                        <img v-else :src="require(`@/templates/${coreParams.theme_name}/assets/no-preview-large.jpg`)" :key="i">
                    </template>
                </slick>
                <div class="image-slider-main-actions">
                    <a href="#" id="sliderMainPrev" class="image-slider-main-action image-slider-main-action--prev" @click.prevent="">
                        <span class="material-icon icon-keyboard_arrow_left"></span>
                    </a>
                    <a href="#" id="sliderMainNext" class="image-slider-main-action image-slider-main-action--next" @click.prevent="">
                        <span class="material-icon icon-keyboard_arrow_right"></span>
                    </a>
                </div>
            </div>
            <div class="image-slider-nav">
                <slick ref="sliderNav" class="slick-slider slick-slider-nav" :options="slickOptionsNav">
                    <template v-for="(img, i) in imgs">
                        <img v-if="img.thumb" :src="img.thumb" :key="i">
                        <img v-else :src="require(`@/templates/${coreParams.theme_name}/assets/no-preview.jpg`)" :key="i">
                    </template>
                </slick>
                <div class="image-slider-nav-actions">
                    <a href="#" id="sliderNavPrev" class="image-slider-nav-action image-slider-nav-action--prev" @click.prevent="">
                        <span class="material-icon icon-keyboard_arrow_left"></span>
                    </a>
                    <a href="#" id="sliderNavNext" class="image-slider-nav-action image-slider-nav-action--next" @click.prevent="">
                        <span class="material-icon icon-keyboard_arrow_right"></span>
                    </a>
                </div>
            </div>
        </template>
        <img v-else-if="imgs.length === 1" :src="_.first(imgs).medium" class="img-fluid w-100">
        <img v-else :src="require(`@/templates/${coreParams.theme_name}/assets/no-preview-large.jpg`)" class="img-fluid w-100">
    </div>
</template>

<script>
  import Slick from 'vue-slick';

  import imageSlider from 'src/mixins/imageSliderComponent';

  export default {
    mixins: [imageSlider],
    components: {
      Slick,
    },
  };
</script>